export const HEAD_ITEMS = {
  RESERVATION_NUMBER: 'Reservation number',
  PARTNER_NUMBER: 'Partner number',
  STATUS: 'Status',
  RESERVED_DATE: 'Reserved date',
  CONFIRMATION_DATE: 'Confirmation date',
  PICKUP_LOCATION: 'Pick-up location',
  PICKUP_DATE: 'Pick-up date',
  DROPOFF_LOCATION: 'Drop-off location',
  DROPOFF_DATE: 'Drop-off date',
  DURATION_IN_DAYS: 'Duration (in days)',
  CAR_PRICE: 'Car price',
  COMPANY_CLASS: 'Company class',
  SIPP_CODE: 'SIPP code',
  EQUIPMENT: 'Equipment',
  CLIENT_NAME_AND_SURNAME: 'Client name, surname',
}

export const BOOKING_HISTORY_TOOLTIP =
  'Showing the current month by default. You can select a different period. Filtering is based on Drop-off Date.'

export const EXPORT_BUTTON_LABEL = 'Export'
